import * as React from 'react';
import { TApiSurveyEntity } from '../../types/Survey';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { simpleDateFormat } from '../../Helpers';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import BallotIcon from '@mui/icons-material/Ballot';
import { SurveyInspectionType } from '../../types/Content';
import { useCurrentActiveSurvey } from '../../hooks/useCurrentActiveSurvey';
import Typography from '@mui/material/Typography';

interface ISurveyListProps {
  surveys: Array<TApiSurveyEntity>;
  onSelect: (id: number) => void;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    icon: {
      backgroundColor: 'white',
      color: 'rgb(141, 198, 63)',
    },
  })
);

const SurveyList: React.FC<ISurveyListProps> = (props): JSX.Element => {
  const classes = useStyles({});
  const { t } = useTranslation();
  const { loadRespondentsStorage, isSurveyCompleted } =
    useCurrentActiveSurvey();
  const incompletedSurveys = loadRespondentsStorage();

  return (
    <List className={classes.root}>
      {props.surveys.map((survey: TApiSurveyEntity) => {
        const isSurvey = survey.surveyType === SurveyInspectionType.SURVEY;
        if (isSurveyCompleted(survey)) return undefined;

        return (
          <ListItem
            button={!props.disabled as any}
            disabled={props.disabled}
            key={survey.id}
            onClick={() => !props.disabled && props.onSelect(survey.id)}
          >
            <ListItemAvatar>
              <Avatar className={classes.icon}>
                {isSurvey ? (
                  <QuestionAnswerIcon fontSize={'large'} />
                ) : (
                  <BallotIcon fontSize={'large'} />
                )}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={survey.title.trim() !== '' ? survey.title : survey.name}
              secondary={
                <React.Fragment>
                  {isSurvey
                    ? `${t('actionplan.endDate')} ${simpleDateFormat(
                        survey.endTime
                      )} `
                    : ''}
                  {
                    incompletedSurveys[survey.id] &&
                    isSurvey && (
                    <Typography
                      display='inline'
                      component='span'
                      variant='body2'
                      color='error'
                    >
                      {t('survey.incomplete')}
                    </Typography>
                  )}
                </React.Fragment>
              }
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default SurveyList;
